import {
    ChangeDetectionStrategy,
    Component,
    Injector,
    Input,
    OnInit,
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { AppStateFacade } from '@app-state';
import {
    FeatureFlag,
    IProcessSettingsState,
} from '@models';
import UiValidators from '@validators';

interface IScreenRecordingControl {
    placeholder: string;
    name: string;
    min: number;
    max: number;
    default: number;
}

const CONTROLS: IScreenRecordingControl[] = [
    {
        placeholder: 'screen_recording_form_quality',
        name: 'quality',
        min: 25,
        max: 100,
        default: 100,
    },
    {
        placeholder: 'screen_recording_form_frequency',
        name: 'frequency',
        min: 250,
        max: 10000,
        default: 500,
    },
    {
        placeholder: 'screen_recording_form_duration',
        name: 'duration',
        min: 1,
        max: 120,
        default: 40,
    },
];

@Component({
    selector: 'ui-process-settings',
    templateUrl: './process-settings.component.html',
    styleUrls: ['./process-settings.components.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessSettingsComponent implements OnInit {
    @Input()
    public state?: IProcessSettingsState;

    public controls = CONTROLS;
    public form: FormGroup;

    private _appState = this._injector.get<AppStateFacade>(AppStateFacade);

    constructor(
        fb: FormBuilder,
        protected _injector: Injector,
    ) {
        const controls = CONTROLS.reduce((acc, curr) => {
            (acc as any)[curr.name] = [
                curr.default,
                Validators.compose([
                    UiValidators.required(),
                    UiValidators.range(curr.min, curr.max, true),
                ]),
            ];
            return acc;
        }, {} as FormControl);

        this.form = fb.group({
            enabled: false,
            autoStartProcess: false,
            ...controls,
        });
    }

    public get isMediaRecordingEnabled() {
        return this._appState.settings.isFeatureEnabled(FeatureFlag.MediaRecording);
    }

    public get isAutoStartEnabled() {
        return this._appState.settings.isFeatureEnabled(FeatureFlag.ProcessSettingAutoStart);
    }

    ngOnInit() {
        const mapState: any = this.state || {};
        Object.keys(mapState).forEach(key => {
            const value = mapState[key];
            if (value != null) {
                this.form.get(key)!.setValue(value);
            }
        });
    }
}
